import React from "react";
import dynamic from "next/dynamic";

const ReactApexChart = dynamic(() => import("react-apexcharts"), {
  ssr: false,
});

const DashboardProjectChart: React.FC = (alldashboardDataList: any) => {
  //   const options = {
  //     series: [
  //       {
  //         name: 'Series 1',
  //         data: [100, 80, 92, 79, 68, 88, 65, 90, 95, 98, 82, 100],
  //       },
  //       {
  //         name: 'Series 2',
  //         data: [80, 60, 82, 59, 48, 78, 45, 70, 85, 90, 72, 85],
  //       },
  //       {
  //         name: 'Series 3',
  //         data: [60, 45, 72, 49, 38, 68, 25, 50, 65, 70, 52, 0],
  //       },
  //     ],
  //     chart: {
  //       height: 350,
  //       type: 'line',
  //       toolbar: {
  //         show: false,
  //       },
  //     },
  //     colors: ['#FF0000', '#FF0000', '#FF0000'],
  //     stroke: {
  //       curve: 'smooth',
  //       width: 4,
  //     },
  //     grid: {
  //       borderColor: '#e7e7e7',
  //       padding: {
  //         top: 10,
  //         right: 10,
  //         bottom: 10,
  //         left: 10,
  //       },
  //     },
  //     xaxis: {
  //       categories: [
  //         'Jan',
  //         'Feb',
  //         'Mar',
  //         'Apr',
  //         'May',
  //         'Jun',
  //         'Jul',
  //         'Aug',
  //         'Sep',
  //         'Oct',
  //         'Nov',
  //         'Dec',
  //       ],
  //     },
  //     yaxis: {
  //       labels: {
  //         style: {
  //           colors: '#000000',
  //         },
  //       },
  //       min: 0,
  //       max: 100,
  //       tickAmount: 5,
  //       tickPlacement: 'on',
  //     },
  //     legend: {
  //       show: false,
  //     },
  //   };

  //   return <ReactApexChart options={options} series={options.series} type="line" height={350} />;
  // };

  //console.log(alldashboardDataList?.alldashboardDataList?.new_client_registration_graph,"alldashboardDataListddddddd");


// Month
  const getMonthName = (monthNumber: number) => {
    const months = [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'June',
      'July',
      'Aug',
      'Sept',
      'Oct',
      'Nov',
      'Dec',
    ];
    return months[monthNumber - 1];
  };


  // Prepare the data in a format that ApexCharts expects
  const newProviderRegistrationSeries =
    alldashboardDataList?.alldashboardDataList?.new_provider_registration_graph?.map(
      (item: any) => item.count
    );
  // const newProviderRegistrationLabels =
  //   alldashboardDataList?.alldashboardDataList?.new_provider_registration_graph?.map(
  //     (item: any) => `Month ${item.month}`
  //   );

  const newProviderRegistrationLabels = alldashboardDataList?.alldashboardDataList?.new_provider_registration_graph?.map((item:any) => getMonthName(item.month));

  const newClientRegistrationSeries =
    alldashboardDataList?.alldashboardDataList?.new_client_registration_graph?.map(
      (item: any) => item.count
    );
  const newClientRegistrationLabels =
    alldashboardDataList?.alldashboardDataList?.new_client_registration_graph?.map(
      (item: any) => `Month ${item.month}`
    );

  

  //console.log(newProviderRegistrationLabels,"getMonthName");



  // Chart options
  const chartOptions = {
    chart: {
      id: "line-chart",
      toolbar: {
        show: false,
        tools: {
          zoomin: false,
          zoomout: false,
          zoom: false,
          pan: false,
          reset: false,
          download: '<img src="/assets/images/down-arrow.svg" width="20">',
        },
      },
    },
    colors: ['#3159FE','#3159fe9e',],
    

    noData: {
      text: "No data found",
      align: "center",
      verticalAlign: "middle",
    },
    xaxis: {
      categories: newProviderRegistrationLabels

      // categories: [
      //   newProviderRegistrationLabels[0]?
      //   "Jan"
      //   : newProviderRegistrationLabels[1] 
      //   ? "Feb"
      //   :"Mar",
      //   "Apr",
      //   "May",
      //   "Jun",
      //   "Jul",
      //   "Aug",
      //   "Sep",
      //   "Oct",
      //   "Nov",
      //   "Dec",
      // ],         // You can also use newClientRegistrationLabels
    },
  };

  return (
    <div>
      {/* Line Chart for New Provider Registration */}
      <ReactApexChart
        options={chartOptions}
        series={[
          {
            name: " Provider",
            data: newProviderRegistrationSeries,
          },
          {
            name: "Client",
            data: newClientRegistrationSeries,
          },
        ]}
        type="line"
        height={350}
      />
    </div>
  );
};

export default DashboardProjectChart;
